export default __webpack_public_path__ + "static/media/avatar_61.b41c139b.png";